"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Metaform REST API
 * REST API for Metaform
 *
 * The version of the OpenAPI document: 2.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
const runtime_1 = require("../runtime");
const _1 = require("./");
function AuditLogEntryFromJSON(json) {
    return AuditLogEntryFromJSONTyped(json, false);
}
exports.AuditLogEntryFromJSON = AuditLogEntryFromJSON;
function AuditLogEntryFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !runtime_1.exists(json, 'id') ? undefined : json['id'],
        'userId': !runtime_1.exists(json, 'userId') ? undefined : json['userId'],
        'replyId': !runtime_1.exists(json, 'replyId') ? undefined : json['replyId'],
        'attachmentId': !runtime_1.exists(json, 'attachmentId') ? undefined : json['attachmentId'],
        'createdAt': !runtime_1.exists(json, 'createdAt') ? undefined : (new Date(json['createdAt'])),
        'message': !runtime_1.exists(json, 'message') ? undefined : json['message'],
        'logEntryType': !runtime_1.exists(json, 'logEntryType') ? undefined : _1.AuditLogEntryTypeFromJSON(json['logEntryType']),
    };
}
exports.AuditLogEntryFromJSONTyped = AuditLogEntryFromJSONTyped;
function AuditLogEntryToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'logEntryType': _1.AuditLogEntryTypeToJSON(value.logEntryType),
    };
}
exports.AuditLogEntryToJSON = AuditLogEntryToJSON;
//# sourceMappingURL=data:application/json;base64,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